import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { DatePipe } from '@angular/common';



@Injectable()
export class DataService {

    apiUrl = 'https://js.devexpress.com/Demos/SalesViewer/api/';
    odataUrl = 'https://js.devexpress.com/Demos/SalesViewer/odata/DaySaleDtoes';


    
    public httpOptionCall(){
        let httpOptions = {
           headers: new HttpHeaders().set(
             "Authorization", 'Bearer '+"ZzwMNw_wTC7l-DbbK87dJRUM6tNJAdQUOblgNzXYapFpGYPo0l-SAvy_pWnagmlB20tYnVYS-CMgUGp5_jxXdoHbdMAk1qxDHnbMHmvj_yB02ptKikUYKu7Gnk_MuV0mfwFUNPMrJIiQeNDSXVAfpZ_BxF7KFMNDQqXcoPyPFoTJLkXGlCUCx4IRfN_fTOOC29EvkDQde5Wcf2AdPgX5SQ7jGnmodBgQwB80nmVWsLmz0Aex7ivxmET_wFSNpoSyRnxCtks5e7PMQZpCUy8xtf3rURBH-NanQa8zrTaP2IsRyDJTP-Uhwf6kv6i4N0TCZC3-HQ8u5FnddVGCsHWJC-QLj0dmMCL-NH0BZr9fNgPfrHqRIJCMODhdaX677HX1"
           ).set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
           .set('Content-Type', 'application/json; charset=utf-8'), 
           params: new HttpParams()
         };
        // httpOptions.headers.append("Authorization", 'Bearer '+this.userservice.DammiToken());
        
         return httpOptions;
       }

       putRegistroRifiuto(Record){
        const BASE_API_URL= 'http://www.wingap.it:7000/';
        const EndPoint=BASE_API_URL+"api/registroRifiuti/put";
        const HeaderOdata=this.httpOptionCall();        
        return  this.http.post(EndPoint,  JSON.stringify(Record),HeaderOdata, 
                )
                .toPromise()
                .then(response  =>response) 
                .catch();
      }

      


    getDataRegistroRifiutoById(Id:any) {
        const BASE_API_URL= 'http://www.wingap.it:7000/';
        const EndPoint=BASE_API_URL+"api/registroRifiuti/getById?id="+Id+"&block=false";
        const HeaderOdata=this.httpOptionCall();
        return  this.http.get<Array<any>>(EndPoint, HeaderOdata 
                )
                .toPromise()
                .then(response  =>response) 
                .catch();
        }
 ListaNsUnitaLocali(){
        const BASE_API_URL= 'http://www.wingap.it:7000/';
        const EndPoint=BASE_API_URL+"api/elenco/getElencoNSUnitaLocali";
        const HeaderOdata=this.httpOptionCall();
        return this.http.get<Array<any>>(EndPoint, HeaderOdata);
    }            
    LoadModelliRegistriRifiuti(){
        const BASE_API_URL= 'http://www.wingap.it:7000/';
        const EndPoint=BASE_API_URL+"api/elenco/getElencoModelli?tipoModello=REGISTRiRIFIUTI";
        const HeaderOdata=this.httpOptionCall();
        return this.http.get<Array<any>>(EndPoint, HeaderOdata);
    }        
           
    getData2() {
    const BASE_API_URL= 'http://www.wingap.it:7000/';
    const EndPoint=BASE_API_URL+"api/elenco/getElencoRegistriRifiuti";
    const HeaderOdata=this.httpOptionCall();
    return this.http.get<Array<any>>(EndPoint, HeaderOdata);
    }

    getData3() {
        const BASE_API_URL= 'http://www.wingap.it:7000/';
        const EndPoint=BASE_API_URL+"api/elenco/getElencoCausali";
        const HeaderOdata=this.httpOptionCall();
        return this.http.get<Array<any>>(EndPoint, HeaderOdata);
        }

    getData(category: string, data: any) {
        let params = new HttpParams();
        let datePipe = new DatePipe('en-US');
        for(let property in data) {
            if (data.hasOwnProperty(property)) {
                if(data[property] instanceof Date) {
                    let format = 'yyyy-MM-dd';
                    if(property === 'now') {
                        format += ' HH:00';
                    }
                    
                    data[property] = datePipe.transform(data[property], format);
                }
                params = params.append(property, data[property]);
            }
        }

        return this.http.get<Array<any>>(this.apiUrl + category, { params: params });
    }
    LoadModelliCausaliRifiuti(){
        const BASE_API_URL= 'http://www.wingap.it:7000/';
        const EndPoint=BASE_API_URL+"api/elenco/getElencoCausali";
        const HeaderOdata=this.httpOptionCall();
        return this.http.get<Array<any>>(EndPoint, HeaderOdata);
    } 
    //Account/GetAll
    getAllUser() {
        const BASE_API_URL= '';
        const EndPoint=BASE_API_URL+"https://www.webrifiuti.it/api/index.php?azione=ReadTabella&table=login";
        const HeaderOdata=this.httpOptionCall();
        return  this.http.get<Array<any>>(EndPoint 
                )
                .toPromise()
                .then(response  =>response) 
                .catch();
        }
      
    operazionibyall(){
        const BASE_API_URL= 'http://www.wingap.it:7000/';
        const EndPoint=BASE_API_URL+"api/elenco/getElencoOperazioniRifiuto";
        const HeaderOdata=this.httpOptionCall();
        return this.http.get<Array<any>>(EndPoint, HeaderOdata);
    } 
    modalitabyall(){
        const BASE_API_URL= 'http://www.wingap.it:7000/';
        const EndPoint=BASE_API_URL+"api/elenco/getElencoModalitaRifiuti?tipo=T";
        const HeaderOdata=this.httpOptionCall();
        return this.http.get<Array<any>>(EndPoint, HeaderOdata);
    } 
    getDataCausaliRifiutoById(Id:any) {

        const BASE_API_URL= 'http://www.wingap.it:7000/';

        const EndPoint=BASE_API_URL+"api/causaliRifiuti/getById?id="+Id+"&block=false";
        const HeaderOdata=this.httpOptionCall();
        return  this.http.get<Array<any>>(EndPoint, HeaderOdata 
                )
                .toPromise()
                .then(response  =>response) 
                .catch();
        }
    constructor(private http: HttpClient) { }


  
}
